import React from 'react'
import { CustomCheckBox } from '../../../components/ui/CustomCheckBox';

interface Props {
    selected: boolean;
    title: string;
    description: string;
}

export const CheckOutPaymentContainer: React.FC<Props> = ({selected,title,description}) => {
    return ( 
        <div style={{
            display:"flex",
            justifyContent:"space-between",
            boxShadow: '0px 4px 4px rgba(11, 37, 89, 0.1)',
            padding: 15
            }}>
            <div>
            <b style={{fontSize:14}}>
                {title}
            </b>
            <div style={{fontSize:14}}>
                {description}
            </div>
            </div>
            <div style={{
                display:"flex",
                justifyContent:"center",
                alignItems:"center"}}>
                <CustomCheckBox selected={selected} />
            </div>
        </div>
    );
}